export default {"src":"/_next/static/media/hospital.f3843a32.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};